import { NAMESPACE_FAVORITES } from 'app/constants/Context';
import { selectAllConflictedIds } from 'app/modules/BetSlip/selectors/conflict';
import { selectBets as bets } from 'app/modules/BetSlip/selectors/entries';
import { addBet } from 'app/modules/Favorites/actions';
import * as gridEntitySelectors from 'app/modules/Favorites/selectors/gridEntities';
import * as gridPresentationSelectors from 'app/modules/Favorites/selectors/gridPresentation';
import * as navigationSelectors from 'app/modules/Navigation/selectors';
import {
  setGridOrderKey,
  setPrematchFavoritesGridStakeTypes,
} from 'app/redux/betting-presentation/grid/actions';

export const favoriteContext = {
  namespace: NAMESPACE_FAVORITES,

  navigation: {
    selectors: navigationSelectors,
  },

  content: {
    selectors: gridEntitySelectors,
  },

  grid: {
    selectors: gridPresentationSelectors,
    actions: {
      setGridOrderKey,
      changeStakeTypeGroup: setPrematchFavoritesGridStakeTypes,
    },
  },

  staking: {
    selectors: { bets, selectAllConflictedIds },
    actions: { addBet },
  },
};
